import { ratioToCalc } from "./index";
import { ImgixAspectRatio } from "../index";
export const zoomAllowedKeys = [
    "Enter",
    "ArrowRight",
    "ArrowLeft",
    "ArrowUp",
    "ArrowDown"
];
export const getNewAxisPositionForKeyPressed = (keyName, previousPosition, maxPosition) => {
    let posX = previousPosition.x;
    let posY = previousPosition.y;
    switch (keyName) {
        case "ArrowRight":
            posX += 50;
            break;
        case "ArrowLeft":
            posX -= 50;
            break;
        case "ArrowUp":
            posY -= 50;
            break;
        case "ArrowDown":
            posY += 50;
            break;
    }
    return {
        x: posX > 0 && posX <= maxPosition.x ? posX : previousPosition.x,
        y: posY > 0 && posY <= maxPosition.y ? posY : previousPosition.y
    };
};
export const shouldCenterImageWithinContainer = (image, zoomFactor) => {
    const imageContainer = image.parentElement;
    return image.offsetHeight * zoomFactor < imageContainer.offsetHeight;
};
export const getMaxCursorPositionForImage = (image, zoomFactor) => {
    if (!image)
        return { x: 0, y: 0 };
    const imageWidth = image.offsetWidth;
    const imageHeight = image.offsetHeight;
    const imageContainer = image.parentElement;
    const getMaxXPositionForImage = () => {
        for (let posX = 0; posX < imageContainer.offsetWidth; posX++) {
            const posXWithinContainerLimits = imageWidth >= posX * (zoomFactor - 1) + imageContainer.offsetWidth;
            if (!posXWithinContainerLimits) {
                return posX - 1;
            }
        }
        return imageContainer.offsetWidth;
    };
    const getMaxYPositionForImage = () => {
        for (let posY = 0; posY < imageContainer.offsetHeight; posY++) {
            const posYWithinContainerLimits = imageHeight >= posY * (zoomFactor - 1) + imageContainer.offsetHeight;
            if (!posYWithinContainerLimits) {
                return posY - 1;
            }
        }
        return imageContainer.offsetHeight;
    };
    return {
        x: getMaxXPositionForImage(),
        y: getMaxYPositionForImage()
    };
};
export const updateImageObjectPositionCss = (image, position, zoomFactor) => {
    const posX = position.x;
    const posY = position.y;
    const targetStyle = image.style;
    targetStyle["object-position"] =
        -posX * (zoomFactor - 1) + "px " + -posY * (zoomFactor - 1) + "px";
};
export const calculateImageMaxDimensions = (image, imgMaxHeight) => {
    const ratio = ratioToCalc(image.aspectRatio || ImgixAspectRatio.ar1x1);
    const imageWidth = imgMaxHeight / ratio;
    const imageHeight = imageWidth * ratio;
    return {
        imageWidth,
        imageHeight
    };
};
//# sourceMappingURL=zoom.js.map